/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from "../ApiClient";
import CreateSensorRequest from '../model/CreateSensorRequest';
import CreateSensorResponse from '../model/CreateSensorResponse';
import ErrorResponse from '../model/ErrorResponse';
import GetSensorResponse from '../model/GetSensorResponse';
import ResponseCommons from '../model/ResponseCommons';
import SearchSensorsResponse from '../model/SearchSensorsResponse';

/**
* Sensors service.
* @module api/SensorsApi
* @version 2020-12-7
*/
export default class SensorsApi {

    /**
    * Constructs a new SensorsApi. 
    * @alias module:api/SensorsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * センサーを有効化する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ResponseCommons} and HTTP response
     */
    activateSensorWithHttpInfo(sensorId) {
      let postBody = null;

      let pathParams = {
        'sensorId': sensorId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseCommons;

      return this.apiClient.callApi(
        '/sensors/{sensorId}/activate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * センサーを有効化する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ResponseCommons}
     */
    activateSensor(sensorId) {
      return this.activateSensorWithHttpInfo(sensorId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * センサーを登録する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CreateSensorResponse} and HTTP response
     */
    createSensorWithHttpInfo(body, opts) {
      opts = opts || {};
      let postBody = body;

      let pathParams = {
      };
      let queryParams = {
        'insert': opts['insert'],
        'upsert': opts['upsert']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CreateSensorResponse;

      return this.apiClient.callApi(
        '/sensors', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * センサーを登録する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CreateSensorResponse}
     */
    createSensor(body, opts) {
      return this.createSensorWithHttpInfo(body, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * センサーを1件取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetSensorResponse} and HTTP response
     */
    getSensorWithHttpInfo(sensorId, opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        'sensorId': sensorId
      };
      let queryParams = {
        'includes': opts['includes'],
        'rangeFrom': opts['rangeFrom'],
        'rangeTo': opts['rangeTo']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetSensorResponse;

      return this.apiClient.callApi(
        '/sensors/{sensorId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * センサーを1件取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetSensorResponse}
     */
    getSensor(sensorId, opts) {
      return this.getSensorWithHttpInfo(sensorId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * センサーを無効化する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ResponseCommons} and HTTP response
     */
    inactivateSensorWithHttpInfo(sensorId) {
      let postBody = null;

      let pathParams = {
        'sensorId': sensorId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseCommons;

      return this.apiClient.callApi(
        '/sensors/{sensorId}/activate', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * センサーを無効化する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ResponseCommons}
     */
    inactivateSensor(sensorId) {
      return this.inactivateSensorWithHttpInfo(sensorId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * センサーを全件取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SearchSensorsResponse} and HTTP response
     */
    searchSensorsWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'groupId': opts['groupId'],
        'serialNo': opts['serialNo'],
        '_with': opts['_with']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SearchSensorsResponse;

      return this.apiClient.callApi(
        '/sensors', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * センサーを全件取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SearchSensorsResponse}
     */
    searchSensors(opts) {
      return this.searchSensorsWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    sensorActivatePreflightWithHttpInfo(sensorId) {
      let postBody = null;

      let pathParams = {
        'sensorId': sensorId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/sensors/{sensorId}/activate', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    sensorActivatePreflight(sensorId) {
      return this.sensorActivatePreflightWithHttpInfo(sensorId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    sensorPreflightWithHttpInfo(sensorId) {
      let postBody = null;

      let pathParams = {
        'sensorId': sensorId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/sensors/{sensorId}', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    sensorPreflight(sensorId) {
      return this.sensorPreflightWithHttpInfo(sensorId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    sensorsPreflightWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/sensors', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    sensorsPreflight() {
      return this.sensorsPreflightWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }

}
